<div class="notification {{ type }}">
  <img class="notification-icon" *ngIf="iconSrc" src="{{ iconSrc }}">
  <div class="notification-content" [innerHTML]="content"></div>
</div>
